import React from "react";
import { ComponentWithAs, Icon, IconProps } from "@chakra-ui/react";

const IconComp: ComponentWithAs<"svg", IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon {...props}>
      <path
        fill="#FFA000"
        d="M64,32c-4.414,0-8,3.586-8,8v40c0,4.414,3.586,8,8,8c4.415,0,8-3.586,8-8V40C72,35.586,68.414,32,64,32z
			 M64,96c-4.414,0-8,3.586-8,8s3.586,8,8,8c4.415,0,8-3.586,8-8S68.414,96,64,96z"
      />

      <path
        fill="#B0BEC5"
        d="M126.314,104.844l-48.001-96C75.603,3.422,70.063,0,64,0c-6.063,0-11.602,3.422-14.313,8.844l-48.001,96
	c-2.477,4.961-2.211,10.852,0.703,15.57C5.303,125.125,10.452,128,15.999,128h96.002c5.547,0,10.695-2.875,13.61-7.586
	C128.525,115.695,128.791,109.805,126.314,104.844z M118.806,116.203c-1.445,2.344-4.055,3.797-6.805,3.797H15.999
	c-2.75,0-5.359-1.453-6.805-3.789c-1.469-2.383-1.602-5.289-0.352-7.789l48.001-96C58.203,9.695,60.945,8,64,8
	c3.055,0,5.797,1.695,7.157,4.422l48.001,95.992C120.407,110.922,120.274,113.828,118.806,116.203z"
      />
    </Icon>
  );
};
IconComp.defaultProps = {
  viewBox: "0 0 128 128",
  boxSize: "20px",
};

export default IconComp;
